import { AttributeType } from 'store/attributes/types';

const isProtocol = (attribute: AttributeType) =>
  Boolean(attribute.allowed_values && attribute.allowed_values.length);

export default isProtocol;
